import React from "react";
import { Box, Typography } from "@mui/material";

import { brand } from "../themes/theme";

/**
 * Tabla reutilizable (grid CSS, no MUI Table) para paneles de datos densos —
 * mismo patron que la rejilla de marcadores de ProfilesView, generalizado.
 * En movil colapsa a filas apiladas (cada celda con su etiqueta de columna).
 *
 * @param {Array} columns - { key, label, width? (fr o px), align? }
 * @param {Array} rows    - objetos con valor por `key` (string o nodo React)
 */
function DataTable({ columns, rows, dense = false }) {
    const template = columns.map((c) => c.width || "1fr").join(" ");

    return (
        <Box>
            <Box
                sx={{
                    display: { xs: "none", md: "grid" },
                    gridTemplateColumns: template,
                    gap: 1.5,
                    px: 1,
                    pb: 0.75,
                    borderBottom: "1px solid",
                    borderColor: brand.gray100,
                }}
            >
                {columns.map((c) => (
                    <Typography
                        key={c.key}
                        sx={{
                            fontSize: 10.5,
                            textTransform: "uppercase",
                            letterSpacing: "0.06em",
                            fontWeight: 600,
                            color: "text.secondary",
                            textAlign: c.align || "left",
                        }}
                    >
                        {c.label}
                    </Typography>
                ))}
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
                {rows.map((row, ri) => (
                    <Box
                        key={ri}
                        sx={{
                            display: "grid",
                            gridTemplateColumns: { xs: "1fr", md: template },
                            gap: { xs: 0.4, md: 1.5 },
                            px: 1,
                            py: dense ? 0.75 : 1.1,
                            borderBottom: "1px solid",
                            borderColor: brand.gray100,
                            "&:last-of-type": { borderBottom: "none" },
                        }}
                    >
                        {columns.map((c) => (
                            <Box key={c.key} sx={{ display: "flex", alignItems: "center", justifyContent: { md: c.align === "right" ? "flex-end" : "flex-start" } }}>
                                {c.label !== "—" && (
                                    <Typography
                                        component="span"
                                        sx={{ display: { xs: "inline", md: "none" }, fontSize: 10, color: "text.secondary", mr: 0.5, textTransform: "uppercase" }}
                                    >
                                        {c.label}:
                                    </Typography>
                                )}
                                {typeof row[c.key] === "string" || typeof row[c.key] === "number" ? (
                                    <Typography sx={{ fontSize: 12.5, color: c.key === columns[0].key ? "text.primary" : "text.secondary", textAlign: { md: c.align || "left" } }}>
                                        {row[c.key]}
                                    </Typography>
                                ) : (
                                    row[c.key]
                                )}
                            </Box>
                        ))}
                    </Box>
                ))}
            </Box>
        </Box>
    );
}

export default DataTable;
